import { createAction } from 'typesafe-actions';
import { IPlayerState } from './IPlayerState';

enum Types {
    SET_PLAYER_STATE = 'setPlayerState',
    UPDATE_TIMERS = 'updateTimers',
    PURCHASE_LIVES = 'purchaseLives',
    RECEIVE_LIVES = 'receiveLives',
    RECEIVE_COINS = 'receiveCoins',
    RECEIVE_KEYS = 'receiveKeys',
    RECEIVE_BOOSTER_TNT = 'receiveBoosterTNT',
    RECEIVE_BOOSTER_BULLSEYE = 'receiveBoosterBullsEye',
    RECEIVE_BOOSTER_SHUFFLE = 'receiveBoosterShuffle',
    RECEIVE_BOOSTER_UNDO = 'receiveBoosterUndo',
    RECEIVE_BOOSTER_JOKER = 'receiveBoosterJoker',
    RECEIVE_EXTRA_CARDS = 'receiveExtraCards',
    SELECT_BACKCARD = 'selectBackCard',
    UNLOCK_BACKCARD = 'unlockBackCard',
    SEE_NEW_BACKCARDS = 'seeNewBackCards',
    SET_MISSION_PROGRESS = 'setMissionProgress',
    RECEIVE_MISSION_REWARD = 'receiveMissionReward',
    RECEIVE_WHEEL_SPINS = 'receiveWheelSpins',
    RECEIVE_FOX_REWARD = 'receiveFoxReward',
    SPIN_WHEEL = 'spinWheel',
    CLEAR_TASKS = 'clearTasks',
    SET_VOLUME_SFX = 'setVolumeSFX',
    SET_VOLUME_MUSIC = 'setVolumeMusic',
    UNLOCK_CHEST = 'unlockChest',
    UNLOCK_POSTCARD = 'unlockPostcard',
    CLAIM_REWARD = 'claimReward',
    SUBMIT_RATE = 'submitRate',
    AGREE_WITH_TERMS = 'agreeWithTerms',
    TOGGLE_NOTIFICATION = 'toggleNotifications',
}

export interface ILivesActionPayload {
    lives: number;
    showPopup?: boolean;
    popupParams?: any;
}

export interface ICoinsActionPayload {
    coins: number;
    showPopup?: boolean;
}

export interface IMissionProgressPayload {
    mission: number;
    progress: number;
}

export const PlayerActions = {
    setPlayerState: createAction(
        Types.SET_PLAYER_STATE,
        resolve => (playerState: IPlayerState) => resolve(playerState)
    ),
    purchaseLife: createAction(Types.PURCHASE_LIVES),
    receiveLives: createAction(
        Types.RECEIVE_LIVES,
        resolve => (lives: number, showPopup?: boolean, popupParams?: any) =>
            resolve<ILivesActionPayload>({ lives, showPopup, popupParams })
    ),
    receiveCoins: createAction(
        Types.RECEIVE_COINS,
        resolve => (coins: number, showPopup?: boolean) =>
            resolve<ICoinsActionPayload>({ coins, showPopup })
    ),
    receiveKeys: createAction(Types.RECEIVE_KEYS, resolve => (keys: number) =>
        resolve<number>(keys)
    ),
    updateTimers: createAction(Types.UPDATE_TIMERS),
    receiveBoosterTNT: createAction(
        Types.RECEIVE_BOOSTER_TNT,
        resolve => (amount: number) => resolve<number>(amount)
    ),
    receiveBoosterBullsEye: createAction(
        Types.RECEIVE_BOOSTER_BULLSEYE,
        resolve => (amount: number) => resolve<number>(amount)
    ),
    receiveBoosterShuffle: createAction(
        Types.RECEIVE_BOOSTER_SHUFFLE,
        resolve => (amount: number) => resolve<number>(amount)
    ),
    receiveBoosterUndo: createAction(
        Types.RECEIVE_BOOSTER_UNDO,
        resolve => (amount: number) => resolve<number>(amount)
    ),
    receiveBoosterJoker: createAction(
        Types.RECEIVE_BOOSTER_JOKER,
        resolve => (amount: number) => resolve<number>(amount)
    ),
    receiveExtraCards: createAction(
        Types.RECEIVE_EXTRA_CARDS,
        resolve => (cards: number) => resolve<number>(cards)
    ),
    selectBackCard: createAction(
        Types.SELECT_BACKCARD,
        resolve => (backcard: string) => resolve<string>(backcard)
    ),
    unlockBackCard: createAction(
        Types.UNLOCK_BACKCARD,
        resolve => (card?: number) => resolve<number>(card)
    ),
    setMissionProgress: createAction(
        Types.SET_MISSION_PROGRESS,
        resolve => (mission: number, progress: number) =>
            resolve<IMissionProgressPayload>({ mission, progress })
    ),
    receiveMissionReward: createAction(
        Types.RECEIVE_MISSION_REWARD,
        resolve => (mission: number) => resolve<number>(mission)
    ),
    seeNewBackcards: createAction(Types.SEE_NEW_BACKCARDS),
    receiveWheelSpins: createAction(
        Types.RECEIVE_WHEEL_SPINS,
        resolve => (spins: number) => resolve<number>(spins)
    ),
    spinWheel: createAction(Types.SPIN_WHEEL),
    receiveFoxReward: createAction(Types.RECEIVE_FOX_REWARD),
    clearTasks: createAction(Types.CLEAR_TASKS),
    setVolumeSFX: createAction(
        Types.SET_VOLUME_SFX,
        resolve => (volume: number) => resolve<number>(volume)
    ),
    setVolumeMusic: createAction(
        Types.SET_VOLUME_MUSIC,
        resolve => (volume: number) => resolve<number>(volume)
    ),
    unlockChest: createAction(
        Types.UNLOCK_CHEST,
        resolve => (chestID: string) => resolve<string>(chestID)
    ),
    unlockPostcard: createAction(
        Types.UNLOCK_POSTCARD,
        resolve => (postcardID: string) => resolve<string>(postcardID)
    ),
    claimReward: createAction(Types.CLAIM_REWARD),
    submitRate: createAction(Types.SUBMIT_RATE),
    agreeWithTerms: createAction(Types.AGREE_WITH_TERMS),
    toggleNotifications: createAction(
        Types.TOGGLE_NOTIFICATION,
        resolve => (notifications: number) => resolve<number>(notifications)
    ),
};
